function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchPolizaFiles, createPolizaFile, updatePolizaFile, deletePolizaFile, getIndexQueryKey } from "./actions/PolizaFileActions";
import { getVersionsQueryKey } from "./actions/BitacoraVersionActions";
import FileGroup from "./FileGroup";
import FileForm from "./FileForm";

var FilesSection = function FilesSection(props) {
  var polizaId = props.polizaId,
      admin = props.admin,
      token = props.token,
      fileTypes = props.fileTypes;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editingFile = _React$useState2[0],
      setEditingFile = _React$useState2[1];

  var queryClient = useQueryClient();
  var indexQueryKey = getIndexQueryKey(polizaId);

  var _useQuery = useQuery({
    queryKey: indexQueryKey,
    queryFn: function queryFn() {
      return fetchPolizaFiles(polizaId);
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 30000 // 30 segundos

  }),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading,
      error = _useQuery.error;

  var refreshList = function refreshList() {
    queryClient.invalidateQueries({
      queryKey: indexQueryKey
    }); // También refrescar el historial de versiones

    queryClient.invalidateQueries({
      queryKey: getVersionsQueryKey(polizaId)
    });
  };

  var handleCreate = function handleCreate(file, fileType) {
    createPolizaFile({
      poliza_id: polizaId,
      file: file,
      file_type: fileType
    }, token).then(function () {
      refreshList();
    })["catch"](function (error) {
      var _error$response;

      console.error("Error creating file:", error);
      console.error("Error details:", (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data);
      alert("Error al subir el archivo");
    });
  };

  var handleUpdate = function handleUpdate(id, file, fileType) {
    var updateData = {
      id: id
    };
    if (file) updateData.file = file;
    if (fileType) updateData.file_type = fileType;
    updatePolizaFile(updateData, token).then(function () {
      refreshList();
      setEditingFile(null);
    })["catch"](function (error) {
      var _error$response2;

      console.error("Error updating file:", error);
      console.error("Error details:", (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data);
      alert("Error al actualizar el archivo");
    });
  };

  var handleDelete = function handleDelete(id) {
    if (confirm("¿Está seguro de eliminar este archivo?")) {
      deletePolizaFile(id).then(function () {
        refreshList();
      })["catch"](function (error) {
        console.error("Error deleting file:", error);
        alert("Error al eliminar el archivo");
      });
    }
  };

  var files = (data === null || data === void 0 ? void 0 : data.poliza_files) || []; // Agrupar archivos por tipo

  var filesByType = {};
  files.forEach(function (file) {
    if (!filesByType[file.file_type]) {
      filesByType[file.file_type] = [];
    }

    filesByType[file.file_type].push(file);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "files-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      marginBottom: "0",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header",
    style: {
      padding: "10px 15px",
      backgroundColor: "#f8f9fa",
      borderBottom: "1px solid #dee2e6"
    }
  }, /*#__PURE__*/React.createElement("h5", {
    style: {
      margin: "0",
      fontSize: "16px",
      fontWeight: "600"
    }
  }, "Archivos")), /*#__PURE__*/React.createElement("div", {
    className: "card-body",
    style: {
      padding: "12px",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement(FileForm, {
    onSubmit: editingFile ? function (file, fileType) {
      return handleUpdate(editingFile.id, file, fileType);
    } : handleCreate,
    fileTypes: fileTypes,
    initialFileType: editingFile === null || editingFile === void 0 ? void 0 : editingFile.file_type,
    onCancel: editingFile ? function () {
      return setEditingFile(null);
    } : undefined
  }), isLoading && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "13px",
      margin: "10px 0",
      color: "#666"
    }
  }, "Cargando archivos...")), !isLoading && files.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "15px",
      flex: 1,
      overflowY: "auto",
      maxHeight: "400px"
    }
  }, fileTypes.map(function (fileType) {
    return /*#__PURE__*/React.createElement(FileGroup, {
      key: fileType.value,
      fileType: fileType,
      files: filesByType[fileType.value] || [],
      admin: admin,
      onEdit: function onEdit(file) {
        return setEditingFile(file);
      },
      onDelete: handleDelete
    });
  })))));
};

export default FilesSection;